module.exports = {"data":{"contributionsJson":{"name":"where to go?","www_url":"http://www.r23.ch","thema":"neue kunstschule","issue_month":"May","issue_year":2005,"issue_date":200505,"artist":"linda","location":"Switzerland","email":"ruth@i-love-u.ch","id":"contribution_95","media_type":"still_image","position_in_section":1,"media_uri":"media/2005/May/photography/ks01.jpg","media_th_uri":"media/2005/May/photography/tn_ks01.jpg","still_image_count":5,"moving_image_count":1,"textz_count":0,"soundz_count":0}},"pathContext":{"id":"contribution_95"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/issue-200505-still-image-1.json
// module id = 763
// module chunks = 100936421349978